export const cveRegex = /^(CVE-)?[1-2]\d{3}-\d{4,8}$/i;

export const getFileHash = async (file: File) => {
    const fileArrayBuffer = await file.arrayBuffer();
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', fileArrayBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const fileHash = hashArray
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();

    return fileHash;
};

type GetFileProgress = (processInfoProgress?: number, scanResultsProgress?: number) => number;

export const getFileProgress: GetFileProgress = (processInfoProgress, scanResultsProgress) => {
    if (typeof processInfoProgress === 'undefined' && typeof scanResultsProgress === 'undefined') {
        return 0;
    }

    if (typeof processInfoProgress === 'number' && typeof scanResultsProgress === 'number') {
        return Math.min(processInfoProgress, scanResultsProgress);
    }

    if (typeof processInfoProgress === 'number' && typeof scanResultsProgress === 'undefined') {
        return processInfoProgress;
    }

    if (typeof processInfoProgress === 'undefined' && typeof scanResultsProgress === 'number') {
        return scanResultsProgress;
    }

    return 100;
};
